export interface STTDeniedGuideProps {
  referrer?: string;
  onComplete?: () => void;
}

export const GUIDE_IMAGES = {
  settings: {
    ltr: '/images/assistant/guide/imgSettingsEng.png',
    rtl: '/images/assistant/guide/imgSettingsAr.png',
  },
  privacySecurity: {
    ltr: '/images/assistant/guide/imgPrivacySecurityEng.png',
    rtl: '/images/assistant/guide/imgPrivacySecurityAr.png',
  },
  speechRecognition: {
    safari: {
      ltr: '/images/assistant/guide/imgSpeechRecognitionSafariEng.png',
      rtl: '/images/assistant/guide/imgSpeechRecognitionSafariAr.png',
    },
    chrome: {
      ltr: '/images/assistant/guide/imgSpeechRecognitionChromeEng.png',
      rtl: '/images/assistant/guide/imgSpeechRecognitionChromeAr.png',
    },
  },
  speechRecognitionDesktop: {
    safari: {
      ltr: '/images/assistant/guide/imgSpeechRecognitionSafariEngDesktop.png',
      rtl: '/images/assistant/guide/imgSpeechRecognitionSafariArDesktop.png',
    },
    chrome: {
      ltr: '/images/assistant/guide/imgSpeechRecognitionChromeEngDesktop.png',
      rtl: '/images/assistant/guide/imgSpeechRecognitionChromeArDesktop.png',
    },
  },
} as const;
